import { PAGE_FORMAT_RELATIVE_EPSILON, RENDERED_PAGE_INDEX } from "./constants";
import type { PlanV3 } from "../../../utils/types";

const toPdfDimension = (imagePixels: number, plan: PlanV3): number => {
  const scaleFactor = plan.pageScaleFactors.get(RENDERED_PAGE_INDEX) ?? 1;
  return scaleFactor === 0 ? Number.NaN : imagePixels / scaleFactor;
};

const areRelativelyEqual = (
  firstDimension: number,
  secondDimension: number,
): boolean => {
  const largest = Math.max(firstDimension, secondDimension);
  if (!(largest > 0)) return false;
  return (
    Math.abs(firstDimension - secondDimension) / largest <=
    PAGE_FORMAT_RELATIVE_EPSILON
  );
};

// Ghosting the before plan's coordinates is only honest when both PDFs share a page format.
export const checkPageFormatMatching = (
  beforePlan: PlanV3,
  afterPlan: PlanV3,
): boolean =>
  areRelativelyEqual(
    toPdfDimension(beforePlan.imageWidthPx, beforePlan),
    toPdfDimension(afterPlan.imageWidthPx, afterPlan),
  ) &&
  areRelativelyEqual(
    toPdfDimension(beforePlan.imageHeightPx, beforePlan),
    toPdfDimension(afterPlan.imageHeightPx, afterPlan),
  );
